// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--1O_yI"};